export const objective = `
id
sk
type
name
idPublisher
content
abbreviation
outlineNumber
scope
createdAt
updatedAt
`;
